import React ,{useState, useEffect} from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import image1 from '../img/shop/1.jpg';

const Shop = () => {
    const [categories, setCategories] = useState([]);
     const [error, setError] = useState(null);


            useEffect(() => {
                   const fetchCategories = async () => {
                       try {
                           const response = await fetch("https://api.welbeing.in/header/");
                           if (!response.ok) {
                               throw new Error('Failed to fetch categories');
                           }
                           const data = await response.json();
                           if (data.status === 'success') {
                               setCategories(data.data);
                           } else {
                               throw new Error(data.error?.message || "Unknown error occurred");
                           }
                       } catch (err) {
                           setError(err.message);
                       } 
                   };
                   fetchCategories();
               }, []);

    return (
        <>
            <Header />
            <main className="main banner-element">
                {/* Breadcrumb Start */}
                <div className="breadcrumb-wrap" id="breadcrumb-margin">
                    <div className="banner" style={{minHeight:'10px'}}>         
                        <img className="bg-img bg-top" src="assets/images/inner-page/banner-p.html" alt="banner" />

                        <div className="container-lg">
                            <div className="breadcrumb-box">
                                <div className="heading-box">
                                    <h1>Shop</h1>
                                </div>
                                <ol className="breadcrumb">
                                    <li><a href="/">Home </a></li>
                                    <li>
                                        <a href="javascript:void(0)"><i data-feather="chevron-right"></i></a>
                                    </li>
                                    <li className="current"><a href="">Shop</a></li>
                                </ol>
                            </div>
                        </div>
                    </div>
                </div>
                {/* Breadcrumb End */}

                {/* Offer Banner 4 Start */}
                <section className="pb-0 offer-banner2 mb-4">
                    <div className="container-lg">
                        <div className="title-box">
                            <h2 className="unique-heading">Categories</h2>
                            <span className="title-divider1"><span className="squre"></span><span className="squre"></span></span>
                        </div>

                        <div className="row ratio2_1 g-3 g-xl-5">
                             {categories.map((categoryGroup) => (
                            <div className='col-md-4'>
                                <details>
                                    <summary className="toggler_1">
                                        <div className='offer-box'>
                                           <img class="bg-img" alt="Thamboolam Bags" src={image1} loading="eager"/>
                                            <div className='content-box'>
                                                <h2><strong>{categoryGroup.category.cate}</strong></h2>
                                                <p>shop with {categoryGroup.category.cate}.</p>
                                            </div>
                                        </div>
                                    </summary>
                                    <div className="tog_contents px-2 d-flex flex-wrap" style={{ gap: '0.5rem' }}>
                                         {categoryGroup.subcategories.map((subcategory) => (
                                        <a href={`products?id=${subcategory.sub_id}`} className='btn btn-solid round-corner btn-sm line-none btn-solid2 mt-2 ml-2'>{subcategory.sub_cate}</a>
                                         ))}
                                        </div>
                                </details>
                            </div>
                             ))}
                           
                           
                        </div>
                    </div>
                </section>
                {/* Offer Banner 4 End */}
            </main>
            <Footer />
        </>
    )
}

export default Shop;